import React from 'react';
import Styles from '../HostedBadge.scss';

export const Fire = (): JSX.Element => {
	return (
		<svg
			className={Styles.fireIconSvg}
			aria-hidden="true"
			focusable="false"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Fire icon</title>
			{/* Outer flame */}
			<path
				className={Styles.fireIconOuter}
				d="M18.375 4.875C15.7721 7.16625 16.125 10.875 16.125 10.875C16.125 10.875 12.3075 5.0595 13.875 0.375C12.3442 3.53438 5.625 4.34625 8.625 13.125C4.82812 11.691 4.875 7.125 4.875 7.125C4.875 7.125 2.625 9.375 2.625 13.875C2.625 16.2619 3.57321 18.5511 5.26104 20.239C6.94887 21.9268 9.23805 22.875 11.625 22.875C14.0119 22.875 16.3011 21.9268 17.989 20.239C19.6768 18.5511 20.625 16.2619 20.625 13.875C20.625 9.315 17.3659 9.32213 18.375 4.875Z"
			/>
			{/* Inner flame */}
			<path
				className={Styles.fireIconInner}
				d="M12 22.875C9 22.875 6 20.25 6 16.125C6.375 18 9.375 18 10.125 18.375C10.875 18.75 8.625 14.25 12 10.875C10.125 13.125 14.25 15.75 14.625 17.25C15 15 15.75 13.875 15.75 13.875C15.75 13.875 19.125 22.875 12 22.875Z"
			/>
		</svg>
	);
};
